"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m12 0a12 12 0 1 0 12 12 12 12 0 0 0 -12-12zm0 23a11 11 0 1 1 11-11 11 11 0 0 1 -11 11z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#e80000"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m12 15.33a1.44 1.44 0 0 0 1.44-1.45v-8.61a1.44 1.44 0 1 0 -2.88 0v8.61a1.45 1.45 0 0 0 1.44 1.45z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "11.99",
    cy: "18.45",
    r: "1.45"
  })));
};

exports["default"] = _default;